(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["see-it-in-action"] && !Shopify.designMode) return;
  try {
    

  (function () {

    function initSection(root) {

      if (
        !root ||
        root.dataset.siiaInitialized === 'true'
      ) {
        return;
      }

      root.dataset.siiaInitialized = 'true';


      var marquee =
        root.querySelector(
          '[data-siia-marquee]'
        );

      var track =
        root.querySelector(
          '[data-siia-track]'
        );

      var cloneTrack =
        root.querySelector(
          '[data-siia-track-clone]'
        );


      if (
        !marquee ||
        !track ||
        !cloneTrack
      ) {
        return;
      }


      var pauseOnHover =
        root.dataset.pauseOnHover === 'true';

      var dragScroll =
        root.dataset.dragScroll === 'true';

      var direction =
        root.dataset.direction || 'left';

      var speedSeconds =
        parseFloat(
          root.dataset.speed
        ) || 30;


      var reduceMotionQuery =
        window.matchMedia(
          '(prefers-reduced-motion: reduce)'
        );


      var isPointerDown = false;

      var startX = 0;

      var startScrollLeft = 0;

      var resumeTimer = null;

      var animationFrame = null;

      var lastTime = 0;

      var cycleWidth = 0;

      var destroyed = false;

      var isHovering = false;


      /*
        Get the actual gap between the two tracks.
      */

      function getGap() {

        var styles =
          window.getComputedStyle(
            marquee
          );

        var gap =
          parseFloat(
            styles.columnGap ||
            styles.gap ||
            0
          );

        return isNaN(gap)
          ? 0
          : gap;

      }


      /*
        Calculate the width of ONE complete
        track plus the gap before the duplicate.
      */

      function updateCycleWidth() {

        cycleWidth =
          track.getBoundingClientRect().width
          + getGap();

        return cycleWidth;

      }


      /*
        Keep scroll position inside the
        duplicated tracks.

        This is what makes manual finger
        swiping infinite.
      */

      function normalizeScrollPosition() {

        if (!cycleWidth) {
          updateCycleWidth();
        }

        if (!cycleWidth) {
          return;
        }


        while (
          marquee.scrollLeft >= cycleWidth
        ) {

          marquee.scrollLeft -= cycleWidth;

        }


        if (
          marquee.scrollLeft <= 0
        ) {

          marquee.scrollLeft += cycleWidth;

        }

      }


      /*
        Start in the duplicated track.

        This gives the user room to swipe
        continuously in both directions.
      */

      function centerOnDuplicateTrack() {

        updateCycleWidth();

        if (!cycleWidth) {
          return;
        }

        marquee.scrollLeft =
          cycleWidth;

      }


      /*
        Stop JavaScript automatic scrolling.
      */

      function stopAutoScroll() {

        if (animationFrame) {

          window.cancelAnimationFrame(
            animationFrame
          );

          animationFrame = null;

        }

        lastTime = 0;

      }


      /*
        Automatic scrolling.

        This replaces the CSS animation ONLY
        when drag/swipe mode is enabled.

        That allows automatic scrolling and
        finger scrolling to use the exact
        same scroll position.
      */

      function startAutoScroll() {

        if (
          destroyed ||
          reduceMotionQuery.matches ||
          !dragScroll
        ) {
          return;
        }


        if (
          isPointerDown ||
          (
            pauseOnHover &&
            isHovering
          )
        ) {
          return;
        }


        stopAutoScroll();


        function step(timestamp) {

          if (destroyed) {
            return;
          }


          if (
            isPointerDown ||
            (
              pauseOnHover &&
              isHovering
            )
          ) {

            animationFrame = null;

            lastTime = 0;

            return;

          }


          if (!lastTime) {

            lastTime = timestamp;

          }


          var delta =
            timestamp - lastTime;

          lastTime = timestamp;


          updateCycleWidth();


          if (
            cycleWidth > 0 &&
            speedSeconds > 0
          ) {

            /*
              One complete track per
              selected speed duration.
            */

            var pixelsPerSecond =
              cycleWidth /
              speedSeconds;


            var movement =
              pixelsPerSecond *
              (delta / 1000);


            if (
              direction === 'right'
            ) {

              marquee.scrollLeft -=
                movement;

            } else {

              marquee.scrollLeft +=
                movement;

            }


            /*
              IMPORTANT:
              Loop before reaching the
              physical end.
            */

            if (
              direction === 'right'
            ) {

              while (
                marquee.scrollLeft <= 0
              ) {

                marquee.scrollLeft +=
                  cycleWidth;

              }

            } else {

              while (
                marquee.scrollLeft >=
                cycleWidth
              ) {

                marquee.scrollLeft -=
                  cycleWidth;

              }

            }

          }


          animationFrame =
            window.requestAnimationFrame(
              step
            );

        }


        animationFrame =
          window.requestAnimationFrame(
            step
          );

      }


      /*
        Resume automatic scrolling shortly
        after the user releases the gallery.
      */

      function scheduleResume() {

        if (resumeTimer) {

          window.clearTimeout(
            resumeTimer
          );

        }


        resumeTimer =
          window.setTimeout(
            function () {

              resumeTimer = null;

              startAutoScroll();

            },
            300
          );

      }


      /*
        Pause on hover.
      */

      function handlePauseOnHover() {

        if (!pauseOnHover) {
          return;
        }


        root.addEventListener(
          'mouseenter',
          function () {

            isHovering = true;

            stopAutoScroll();

          }
        );


        root.addEventListener(
          'mouseleave',
          function () {

            isHovering = false;

            if (!isPointerDown) {

              startAutoScroll();

            }

          }
        );

      }


      /*
        MANUAL TOUCH / MOUSE DRAG
      */

      function handleDragScroll() {

        if (
          !dragScroll ||
          reduceMotionQuery.matches
        ) {
          return;
        }


        marquee.setAttribute(
          'data-siia-dragscroll',
          'true'
        );


        /*
          Disable CSS animation because
          JavaScript now controls the
          exact same scroll position.
        */

        track.style.animation = 'none';

        cloneTrack.style.animation = 'none';

        track.style.transform = 'none';

        cloneTrack.style.transform = 'none';


        /*
          START DRAG
        */

        function beginDrag(event) {

          if (
            event.pointerType === 'mouse' &&
            event.button !== 0
          ) {
            return;
          }


          updateCycleWidth();


          if (!cycleWidth) {
            return;
          }


          isPointerDown = true;

          startX =
            event.clientX;

          startScrollLeft =
            marquee.scrollLeft;


          stopAutoScroll();


          marquee.classList.add(
            'is-dragging'
          );


          if (
            marquee.setPointerCapture
          ) {

            try {

              marquee.setPointerCapture(
                event.pointerId
              );

            } catch (error) {}

          }


          event.preventDefault();

        }


        /*
          MOVE DRAG
        */

        function moveDrag(event) {

          if (!isPointerDown) {
            return;
          }


          var delta =
            event.clientX -
            startX;


          marquee.scrollLeft =
            startScrollLeft -
            delta;


          /*
            LOOP WHEN MOVING FORWARD.
          */

          if (
            marquee.scrollLeft >=
            cycleWidth
          ) {

            marquee.scrollLeft -=
              cycleWidth;

            startScrollLeft -=
              cycleWidth;

          }


          /*
            LOOP WHEN MOVING BACKWARD.

            This is the part that prevents
            the gallery from becoming "finished"
            when swiping continuously to the
            other direction.
          */

          else if (
            marquee.scrollLeft <= 0
          ) {

            marquee.scrollLeft +=
              cycleWidth;

            startScrollLeft +=
              cycleWidth;

          }


          event.preventDefault();

        }


        /*
          END DRAG
        */

        function endDrag(event) {

          if (!isPointerDown) {
            return;
          }


          isPointerDown = false;


          marquee.classList.remove(
            'is-dragging'
          );


          if (
            event &&
            marquee.releasePointerCapture
          ) {

            try {

              if (
                marquee.hasPointerCapture(
                  event.pointerId
                )
              ) {

                marquee.releasePointerCapture(
                  event.pointerId
                );

              }

            } catch (error) {}

          }


          normalizeScrollPosition();


          scheduleResume();

        }


        marquee.addEventListener(
          'pointerdown',
          beginDrag,
          {
            passive: false
          }
        );


        marquee.addEventListener(
          'pointermove',
          moveDrag,
          {
            passive: false
          }
        );


        marquee.addEventListener(
          'pointerup',
          endDrag,
          {
            passive: true
          }
        );


        marquee.addEventListener(
          'pointercancel',
          endDrag,
          {
            passive: true
          }
        );


        marquee.addEventListener(
          'lostpointercapture',
          function () {

            if (isPointerDown) {

              endDrag();

            }

          },
          {
            passive: true
          }
        );


        /*
          Allow vertical page scrolling while
          this section handles horizontal drag.
        */

        marquee.style.touchAction =
          'pan-x pan-y pinch-zoom';


        /*
          Start from the duplicate copy.
        */

        window.requestAnimationFrame(
          function () {

            centerOnDuplicateTrack();

            startAutoScroll();

          }
        );

      }


      /*
        Reduced motion support.
      */

      function handleReducedMotion() {

        function apply() {

          if (
            reduceMotionQuery.matches
          ) {

            stopAutoScroll();

            marquee.style.overflowX =
              'auto';

            track.style.animation =
              'none';

            cloneTrack.style.animation =
              'none';

          }

          else if (dragScroll) {

            marquee.style.overflowX =
              'auto';

            startAutoScroll();

          }

        }


        apply();


        if (
          reduceMotionQuery.addEventListener
        ) {

          reduceMotionQuery.addEventListener(
            'change',
            apply
          );

        }

      }


      /*
        Recalculate after screen resize.
      */

      window.addEventListener(
        'resize',
        function () {

          updateCycleWidth();


          if (!isPointerDown) {

            normalizeScrollPosition();

          }

        },
        {
          passive: true
        }
      );


      handlePauseOnHover();

      handleDragScroll();

      handleReducedMotion();


      /*
        If drag/swipe is disabled,
        keep the original CSS marquee.
      */

      if (!dragScroll) {

        if (
          reduceMotionQuery.matches
        ) {

          marquee.style.overflowX =
            'auto';

        }

      }

    }


    /*
      Initialize sections already on page.
    */

    document
      .querySelectorAll(
        '[data-section-id][id^="see-it-in-action-"]'
      )
      .forEach(
        initSection
      );


    /*
      Shopify theme editor support.
    */

    document.addEventListener(
      'shopify:section:load',
      function (event) {

        var root =
          event.target.querySelector
            ? event.target.querySelector(
                '[id^="see-it-in-action-"]'
              )
            : null;


        if (root) {

          initSection(root);

        }

      }
    );


    document.addEventListener(
      'shopify:section:unload',
      function (event) {

        var root =
          event.target.querySelector
            ? event.target.querySelector(
                '[id^="see-it-in-action-"]'
              )
            : null;


        if (root) {

          root.dataset.siiaInitialized =
            'false';

        }

      }
    );


    /*
      Shopify block selection.
    */

    document.addEventListener(
      'shopify:block:select',
      function (event) {

        var blockElement =
          event.target;


        if (
          !blockElement ||
          !blockElement.closest
        ) {
          return;
        }


        var root =
          blockElement.closest(
            '[id^="see-it-in-action-"]'
          );


        if (!root) {
          return;
        }


        root.classList.add(
          'is-paused'
        );


        blockElement.scrollIntoView({
          behavior: 'smooth',
          inline: 'center',
          block: 'nearest'
        });

      }
    );


    document.addEventListener(
      'shopify:block:deselect',
      function (event) {

        var blockElement =
          event.target;


        if (
          !blockElement ||
          !blockElement.closest
        ) {
          return;
        }


        var root =
          blockElement.closest(
            '[id^="see-it-in-action-"]'
          );


        if (!root) {
          return;
        }


        root.classList.remove(
          'is-paused'
        );

      }
    );

  })();


  } catch(e) { console.error(e); }
})();
})();
